import { render } from "./manage-user.vue?vue&type=template&id=19b819fa&scoped=true"
import script from "./manage-user.vue?vue&type=script&lang=js"
export * from "./manage-user.vue?vue&type=script&lang=js"

import "./manage-user.vue?vue&type=style&index=0&id=19b819fa&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b819fa"]])

export default __exports__